import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs/internal/Subject';
import { MAIN_DOMAIN } from '@app/app.constants';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import { Pupil, StudentPrivilegeSetting } from '@df/interfaces';
import { PrivilegeService } from '@app/core/services/privilege.service';
import { Lesson } from '../../../definitions/interfaces/lesson';

@Component({
    selector: 'app-privilege-icon',
    templateUrl: './privilege-icon.component.html',
    styleUrls: ['./privilege-icon.component.scss']
})
export class PrivilegeIconComponent implements OnInit, OnDestroy {
    @Input() student: Pupil;
    @Input() lesson: Lesson;

    MAIN_DOMAIN: string = MAIN_DOMAIN;
    studentPrivileges: Array<StudentPrivilegeSetting> = [];

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private privilegeSvc: PrivilegeService) {}

    public ngOnInit(): void {
        if (this.student.id && this.lesson && this.lesson.privileges.length > 0) {
            this.privilegeSvc
                .getStudentPrivilegeSettingsForLesson(this.student.id, this.lesson.id)
                .pipe(takeUntil(this.destroy$))
                .subscribe(resp => {
                    this.studentPrivileges = resp.results;
                });
            this.pollinGetStudentPrivileges();
        }
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
    }

    private pollinGetStudentPrivileges(): void {
        this.privilegeSvc
            .pollingGetStudentPrivilege(this.student.id, this.lesson.id, 5000)
            .pipe(takeUntil(this.destroy$))
            .subscribe(resp => {
                this.studentPrivileges = resp.results;
            });
    }
}
